import { IConfiguration, IPluginASOConfiguration } from "../../models/configuration/plugin/IConfiguration";
import { Action, ActionType } from "../actions";

interface ConfigASOPluginDataState {
    loading: boolean;
    error: string | null;
    configIds?: string[];
    configData: IConfiguration | null;
}

const initialState: ConfigASOPluginDataState = { loading: false, error: null, configIds: [], configData: null };

const configASOPluginReducer = (
    state: ConfigASOPluginDataState = initialState,
    action: Action
): ConfigASOPluginDataState => {
    switch (action.type) {
        case ActionType.GET_ASO_CONFIG_PLUGIN_DATA:
            return { ...state, loading: true, error: null };
        case ActionType.GET_ASO_CONFIG_PLUGIN_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ActionType.GET_ASO_CONFIG_PLUGIN_DATA_SUCCESS: {
            const payload = action.payload as IPluginASOConfiguration;
            return {
                ...state,
                loading: false,
                error: null,
                configData: payload.AsoConfig,
                configIds: payload.ConfigurationIds
            };
        }
        default:
            return state;
    }
};

export default configASOPluginReducer;